import React, {useState, useEffect} from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentPage, setOrder, setOrderBy,setRowsPerPage,setSelectAll,setSelectAllPendig,updateSelectedRowsPending, updateSelectedRows} from 'reducers/paginationFormDISlice';
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import DeleteIcon from '@mui/icons-material/Delete'; 
import EditIcon from '@mui/icons-material/Edit'; 
import IconButton from '@mui/material/IconButton'; 
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Paper from '@mui/material/Paper';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import useTheme from '@mui/material/styles/useTheme';
import visuallyHidden from '@mui/utils/visuallyHidden'; 
import "css/customDialog.css";
import PropTypes from 'prop-types';

const headCellsSHEET = [
  { id: 'ownsheet_id', numeric: false, disablePadding: false, label: 'Text_Code', canOrder: true },
  { id: 'date_sheet', numeric: false, disablePadding: false, label: 'Text_SHEET_DATE', canOrder: true },
  { id: 'num_sheet', numeric: false, disablePadding: false, label: 'Text_SHEET_NUM', canOrder: true },
  { id: 'vehicle_marca', numeric: false, disablePadding: false, label: 'Text_SHEET_MARCA', canOrder: true },
  { id: 'vehicle_model', numeric: false, disablePadding: false, label: 'Text_SHEET_MODEL', canOrder: true },
  { id: 'vehicle_sheet', numeric: false, disablePadding: false, label: 'Text_SHEET_LICENSEPLATE', canOrder: true },
  { id: 'frame_sheet', numeric: false, disablePadding: false, label: 'Text_SHEET_FRAME', canOrder: true },
  { id: 'sheetStatus_name', numeric: false, disablePadding: false, label: 'Text_SHEET_STATUS', canOrder: true }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
  
function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
          return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t,showFinishButtonSHEET,showEditButtonSHEET,showPrintButtonSHEET,showDeleteButtonSHEET,showStoreSHEET,selectAll,selectAllPendig,handleChangSelectAll,handleChangSelectAllPending,typeOfList } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
      {showEditButtonSHEET &&
          <TableCell
            key='edit'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {t('Button_Edit')}
            </Typography>
          </TableCell>
        }
        {showPrintButtonSHEET &&
          <TableCell
            key='print'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 16}} >
              {t('Button_Print_PDF')}
            </Typography>
          </TableCell>
        }
        {showFinishButtonSHEET &&
          <TableCell
            key='pending'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#4e73df", fontSize: 16}} >
              {typeOfList==="1"?t('Text_Finish'):t('Text_Return')}
            </Typography>
            <Checkbox checked={typeOfList==="1"?selectAll:selectAllPendig} style={{color:"#4e73df", fontSize: 16}} 
              sx={{
                '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
              }}
              onClick={typeOfList==="1"?()=>handleChangSelectAll():()=>handleChangSelectAllPending()}
            />
          </TableCell>
        }
        {headCellsSHEET.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
        
        {showDeleteButtonSHEET &&
          <TableCell
            key='delete'
            align='center'
            padding='normal'
            sortDirection={false}
          >
            <Typography style={{color:"#e74a3b", fontSize: 16}} > 
              {t('Button_Delete')}
            </Typography>
          </TableCell>
        }
        {showStoreSHEET &&
          <TableCell
            key='tradename'
            align='center'
            padding='normal'
            sortDirection={order}
          >
            <TableSortLabel
              active={orderBy === 'tradename'}
              direction={orderBy === 'tradename' ? order : 'asc'}
              onClick={createSortHandler('tradename')}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t('Text_Store_Create')}
                {orderBy === 'tradename' ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>
          </TableCell>
        }  
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { textHead, textReg, numTotRegFilter,numTotRegSHEET, textOf  } = props;
    return (
      <Toolbar>
        <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 28}} id="tableTitle" component="div">
          {textHead}
        </Typography>
        <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
          {textReg} {(numTotRegFilter).toLocaleString('de-DE')} {textOf} {(numTotRegSHEET).toLocaleString('de-DE')}
        </Typography>
    </Toolbar>
    );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataGeneralSettings']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingSHEET =(props)=>{
  const { 
    dataSHEET,
    setDataSHEET,
    setFormSHEET,
    numTotRegFilter,
    titleTable,
    setOpenDeleteRowSHEET,
    setRowEditSHEET, 
    showFinishButtonSHEET,
    showEditButtonSHEET,
    showPrintButtonSHEET,
    showDeleteButtonSHEET, 
    showStoreSHEET, 
    numTotRegSHEET,
    activeOffsetSHEET,
    rangeOffsetSHEET,
    currencyOffsetSHEET,
    setCurrencyOffsetSHEET,
    setViewPDF,
    typeOfList
  } = props;
  const {t,i18n} = useTranslation(['listDataForms']);
  const dispatch = useDispatch();
  const { currentPage, order, orderBy,rowsPerPage,selectAll,selectAllPendig,selectedRowsPending,selectedRows} = useSelector((state) => state.paginationFormDI);
  const [countData,setCountData] = useState(dataSHEET.length);
  const maxPage = Math.max(0, Math.ceil(countData / rowsPerPage) - 1);
  const page = Math.min(currentPage, maxPage);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataSHEET.length) : 0);
  
  useEffect(
    () => {
      setCountData(dataSHEET.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataSHEET.length) : 0);  
    },
    [dataSHEET,page,setEmptyRows,rowsPerPage,countData]
  );

  useEffect(() => {
    const updatedRowsPending = dataSHEET.map(item => ({
      ...item,
      isFinished: selectedRowsPending[item.id] || selectAll
    }));
    
    // Evita llamar setDataSHEET si los datos no cambian
    if (JSON.stringify(updatedRowsPending) !== JSON.stringify(dataSHEET))  {
      setDataSHEET(updatedRowsPending);
    }
  }, [dataSHEET, selectedRowsPending,setDataSHEET,selectAll]);
  
      
    // Mantén los otros useEffect que ya tienes
    useEffect(() => {
      const updatedRows = dataSHEET.map((item) => ({
        ...item,
        isPending: selectedRows[item.id] || selectAllPendig,
      }));
    
      // Solo actualiza si hay cambios reales
      if (JSON.stringify(updatedRows) !== JSON.stringify(dataSHEET)) {
        setDataSHEET(updatedRows);
      }
    }, [selectedRows,dataSHEET,setDataSHEET,selectAllPendig]); // Elimina dataPurchaseDelivery de las dependencias
    
  const handleChangeOffset = (event) => {
    setCurrencyOffsetSHEET(event.target.value);
  };

  const handleRequestSort = (event, property) => {
     const isAsc = orderBy === property && order === 'asc';
     dispatch(setOrder(isAsc ? 'desc' : 'asc')); // Actualiza Redux
     dispatch(setOrderBy(property)); // Actualiza Redux
  };

  const handleChangePage = (event, newPage) => {
    dispatch(setCurrentPage(newPage)); // Guardar la página actual en Redux
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    dispatch(setRowsPerPage(newRowsPerPage)); // Guardar el número de elementos por página actual en Redux
    dispatch(setCurrentPage(0)); // Reiniciar la página cuando cambian las filas por página
  };

  const openModalDeleteRowSHEET = (row) => {
    setRowEditSHEET(row);
    setOpenDeleteRowSHEET(true);
  };

  const openModalSHEETPDF = async (row) => {
    setRowEditSHEET(row);
    setViewPDF(true);
  };
 
  const openModalEdit = async (row) => {
    setRowEditSHEET(row);
    setViewPDF(false);
  };
  
  const handleChangSelectAll = () => { 
    const newSelectAll = !selectAll;
    const updatedSelectedRows = dataSHEET.reduce((acc, item) => {
      acc[item.id] = newSelectAll;
      return acc;
    }, {});

    dispatch(setSelectAll(newSelectAll));
    dispatch(updateSelectedRowsPending(updatedSelectedRows));
    const updatedRows = dataSHEET.map(item => ({
      ...item,
      isFinished: newSelectAll,
    })); 
    setDataSHEET(updatedRows);
    setFormSHEET(formFormDI => ({
    ...formFormDI,
    }));
  };

   
  const handleChangSelectAllPending = () => {
    const newSelectAllPending = !selectAllPendig;
    const updatedSelectedRows = dataSHEET.reduce((acc, item) => {
      acc[item.id] = newSelectAllPending;
      return acc;
    }, {});
    dispatch(setSelectAllPendig(newSelectAllPending));
    dispatch(updateSelectedRows(updatedSelectedRows)); // Un único dispatch con todos los registros
    const updatedRows = dataSHEET.map(item => ({
      ...item,
      isPending: newSelectAllPending,
    }));
    setDataSHEET(updatedRows);
    setFormSHEET(formFormDI => ({
      ...formFormDI,
    }));
  };

   
  const handleChangeEnabledRow = (row) => {
    const updatedRowsPending = dataSHEET.map(item =>
      item.id === row.id ? { ...item, isFinished: !item.isFinished } : item
    );
    setDataSHEET(updatedRowsPending); 
    dispatch(updateSelectedRowsPending({ 
      id: row.id, 
      isFinished: !row.isFinished 
    }));
    setFormSHEET(formFormDI => ({
      ...formFormDI,
    }));
  };

  const handleChangeEnabledPendingRow = (row) => {
    const updatedRows = dataSHEET.map(item =>
      item.id === row.id ? { ...item, isPending: !item.isPending } : item
    );
    setDataSHEET(updatedRows);
    dispatch(updateSelectedRows({
      id: row.id,
      isPending: !row.isPending,
    }));
    setFormSHEET((formFormDI) => ({
      ...formFormDI,
    }));
  }; 
   
  const listItems = stableSort(dataSHEET, getComparator(order, orderBy))
  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
  .map((row, keyData) => {
    return (
      <TableRow hover tabIndex={-1} key={keyData}>
        {(showEditButtonSHEET && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <Link  
              to={typeOfList === "1" ? `/sheetdetail/${row.id}` : `/sheetdetailhome/${row.id}`} onClick={()=>openModalEdit(row)}>
              <IconButton size="large" className="edit-icon-button">
                <EditIcon style={{fontSize: 28}}/>
              </IconButton>
            </Link> 
          </TableCell>
        }
        {(showPrintButtonSHEET && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <IconButton size="large" className="print-icon-button" onClick={() => openModalSHEETPDF(row)}>
              <PictureAsPdfIcon  style={{fontSize: 28}}/>
            </IconButton>
          </TableCell>
        }
        {(showFinishButtonSHEET && row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <Checkbox checked={typeOfList==="1"?row.isFinished:row.isPending} style={{color:"#4e73df", fontSize: 16}}  
            sx={{
              '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
            }}
            onClick={typeOfList==="1"?()=>handleChangeEnabledRow(row):()=>handleChangeEnabledPendingRow(row)}
          />
          </TableCell>
        }
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {row.ownsheet_id}
          </Typography>  
        </TableCell>
        <TableCell align="right">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.date_sheet!==null && row.date_sheet!==""?new Date(row.date_sheet).toLocaleDateString(i18n.language==="es"?'es-ES':'en-US'):""}
           </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.num_sheet}
          </Typography>
        </TableCell>
          <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.vehicle_marca}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.vehicle_model}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.vehicle_sheet}
          </Typography>
        </TableCell> 
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {row.frame_sheet}
          </Typography>
        </TableCell> 
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16}} >
            {i18n.language==='es'?row.sheetStatus_namees:row.sheetStatus_nameen}
          </Typography>
        </TableCell> 
        {(showDeleteButtonSHEET && row.id!=="" && row.id!==null) &&
          <TableCell align="center">
            <IconButton size="large" className="delete-icon-button" onClick={() => openModalDeleteRowSHEET(row)}> 
              <DeleteIcon  style={{fontSize: 28}}/>
            </IconButton>
          </TableCell>}
        {showStoreSHEET  &&
          <TableCell align="left">
            <Typography style={{color:"#000000", fontSize: 16}} >
              {row.tradename}
            </Typography>  
          </TableCell>
        }   
      </TableRow>
    );
  });
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar textHead={t(titleTable)} textReg={t('Text_Num_Reg')} numTotRegFilter={numTotRegFilter} numTotRegSHEET={numTotRegSHEET} textOf={t('Text_Of')}/>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 750 }} aria-labelledby="tableTitle" size='small'>
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} t={t}  showFinishButtonSHEET={showFinishButtonSHEET} showEditButtonSHEET={showEditButtonSHEET} showPrintButtonSHEET={showPrintButtonSHEET} showDeleteButtonSHEET={showDeleteButtonSHEET} showStoreSHEET={showStoreSHEET} selectAll={selectAll} selectAllPendig={selectAllPendig} handleChangSelectAll={handleChangSelectAll} handleChangSelectAllPending={handleChangSelectAllPending} typeOfList={typeOfList}/>
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={16} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffsetSHEET && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetSHEET"
                            name="currencyOffsetSHEET"
                            value={currencyOffsetSHEET}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetSHEET
                            }}>
                            {rangeOffsetSHEET.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={16}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingSHEET.propTypes = {
  dataSHEET: PropTypes.array.isRequired,
  setFormSHEET: PropTypes.func.isRequired,
  numTotRegFilter: PropTypes.number.isRequired,
  titleTable : PropTypes.string.isRequired,
  setOpenDeleteRowSHEET: PropTypes.func.isRequired, 
  setRowEditSHEET: PropTypes.func.isRequired,    
  showFinishButtonSHEET: PropTypes.bool.isRequired,  
  showEditButtonSHEET: PropTypes.bool.isRequired,  
  showPrintButtonSHEET: PropTypes.bool.isRequired,  
  showDeleteButtonSHEET: PropTypes.bool.isRequired,
  showStoreSHEET: PropTypes.bool.isRequired, 
  activeOffsetSHEET: PropTypes.bool.isRequired,
  rangeOffsetSHEET: PropTypes.array.isRequired,
  currencyOffsetSHEET: PropTypes.number.isRequired,
  setCurrencyOffsetSHEET: PropTypes.func.isRequired,
  setViewPDF: PropTypes.func.isRequired,
  typeOfList: PropTypes.string.isRequired 
};
  
export default TableSortingSHEET;
